import { combineReducers } from 'redux';
import {
    SET_TIMER_CURRENT_ID,
    SET_TIMER_CURRENT_TIME,
} from '../../../common/actions/SurveyTimerActions';
import { GET_ACTIVE_QUESTIONNAIRES_SUCCESS } from '../../../constants/actions/users.constants';
import { LOGOUT } from '../../../constants/actions/auth.constants';
import QuestionnaireActions from '../../../participant/actions/QuestionnaireActions';

interface CurrentIdAction {
    type: string;
    payload: number;
    error?: string;
}

const currentId = (state: number | null = null, action: CurrentIdAction) => {
    switch (action.type) {
        case SET_TIMER_CURRENT_ID:
            return action.payload;
        case GET_ACTIVE_QUESTIONNAIRES_SUCCESS:
            return action.payload?.[0]?.id || null;
        case QuestionnaireActions.closeQuestionnaire.type:
        case LOGOUT:
            return null;
        default:
            return state;
    }
};

interface TimeAction {
    type: string;
    payload: number;
    error?: string;
}

const time = (state: number = 0, action: TimeAction) => {
    switch (action.type) {
        case SET_TIMER_CURRENT_TIME:
            return action.payload;
        case GET_ACTIVE_QUESTIONNAIRES_SUCCESS:
            return (
                action.payload?.[0]?.sections?.[0]?.subsections?.[0]
                    ?.remainingTime || 0
            );
        case QuestionnaireActions.closeQuestionnaire.type:
        case LOGOUT:
            return 0;
        default:
            return state;
    }
};

export default combineReducers({ currentId, time });
